export const FETCH_AWARD = 'FETCH_AWARD';
export const PARTICIPANT_COMPANIES = 'PARTICIPANT_COMPANIES';
